import { render, staticRenderFns } from "./TaskDataPointItem.vue?vue&type=template&id=38505665&scoped=true&"
import script from "./TaskDataPointItem.vue?vue&type=script&lang=ts&"
export * from "./TaskDataPointItem.vue?vue&type=script&lang=ts&"
import style0 from "./TaskDataPointItem.vue?vue&type=style&index=0&id=38505665&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38505665",
  null
  
)

export default component.exports